import {startDigits} from '../../../constants';

export default {
  receiveInformationShares: false,
  receiveInformationOffers: false,
  receiveSurveyInformation: false,
  phoneNumber: '9061478529',
  email: null,
  usc: `${startDigits}112960209587`,
  events: {
    isSms: false,
    isEmail: false,
  },
};
